<template>
  <v-container fluid class="background-white fill-height">
    <v-row class="no-gutters flex-wrap flex-column fill-height">
      <v-col cols="auto">
        <campaign-image :imageUrl="campaign.logo" />
        <v-sheet>
          <div class="pa-4 px-8 text-center text-body-2">
            {{ campaign.description }}
          </div>
          <div class="px-8 text-center font-weight-medium text-body-2 py-4" style="font-size: 1.1rem">
            {{ survey.question }}
          </div>
        </v-sheet>
      </v-col>
      <v-col
        cols="auto"
        class="grow gray mb-8"
        v-if="campaign.sorting_type === 1"
      >
        <option-card
          v-for="(option, index) in survey.answers"
          :key="index"
          :option="option"
          @option-selected="submitOption(option)"
        />
      </v-col>
      <div class="text-center text-body-2 px-8 py-4 pb-12 text-center">
            {{ survey.footer_message }}
          </div>
    </v-row>
  </v-container>
</template>

<script>
import apiService from '@/services'
import optionCard from './SurveyOptionCard'
// mport npoRow from './QrcodeNpoRow'
import campaignImage from '@/components/qrcode-vote-components/BaseHeaderImage'

export default {
  components: {
    'option-card': optionCard,
    'campaign-image': campaignImage
  },
  data () {
    return {
      imageUrl: '@/assets/the_good_company_logo.jpg',
      searchClient: '',
      isActive: false,
      campaign: {},
      survey: {},
      dataLoading: true,
      npos: {
        data: [],
        total: 0
      }
    }
  },

  computed: {
    rulesUrl () {
      return `${process.env.VUE_APP_BASE_URL}/campaigns/${this.campaign.campaign}/download/rules`
    },
    filteredNpos () {
      const filter = this.searchClient.toLowerCase().trim()
      console.log(filter)
      if (!filter) return this.npos.data
      var tmpNpo = this.npos.data.filter(
        (npo) => npo.name.toLowerCase().indexOf(filter) > -1
      )
      console.log('TMP_NPO', tmpNpo)

      return tmpNpo
    }
  },

  created () {
    // Get related survey

    // Check if campaign is leading
    if (this.$route.params.campaignId) {
      sessionStorage.setItem('campaign_id', this.$route.params.campaignId)
    }

    if (this.$route.params.token) {
      sessionStorage.setItem('qrcodeToken', this.$route.params.token)
    }

    if (this.$route.params.isLeading) {
      sessionStorage.setItem('isLeading', this.$route.params.isLeading)
    }

    if (this.$route.params.logo) {
      sessionStorage.setItem('logo', this.$route.params.logo)
    }
    this.campaign = JSON.parse(sessionStorage.getItem('campaign'))
    this.$vuetify.theme.themes.light.primary = this.campaign.primary_color
    this.$vuetify.theme.themes.light.secondary = this.campaign.secondary_color
    this.getCampaignSurvey(sessionStorage.getItem('campaign_id'))
    this.campaign.skipConfig = true
  },

  methods: {
    // GET Npos
    getCampaignSurvey (campaignId) {
      apiService
        .getSurvey(campaignId)
        .then((response) => {
          this.survey = response.data
          sessionStorage.setItem('survey', JSON.stringify(this.survey))

          this.dataLoading = false
        })
        .catch((error) => {
          console.log(error)
        })
    },
    submitOption (optionId) {
      let params = {
        survey_answer: optionId.id,
        token: sessionStorage.getItem('qrcodeToken')
      }
      apiService
        .saveOption(params)
        .then((response) => {
          let params = {
            npoId: this.survey.id,
            // logo: npo.logo,
            npo: optionId,
            title: 'Hai scelto',
            token: sessionStorage.getItem('qrcodeToken')
          }
          this.$router.push({
            name: 'qrcodesurveyresult',
            params: params
          })
          this.npos.data = response.data
          this.npos.total = response.data.length
          this.dataLoading = false
        })
        .catch((error) => {
          console.log(error)
        })
    },
    filteredElem (filterValue) {
      var data = this.filteredNpos.filter(npo => npo.area[0].name === filterValue)
      console.log(data)
      return data
    },
    filteredNpos3 (index) {
      const searchFilter = this.searchClient.toLowerCase().trim()
      if (!searchFilter) return this.npos.data[index].npos

      return this.npos.data[index].npos.filter((npo) => {
        return npo.name.toLowerCase().indexOf(searchFilter) > -1
      })
    },
    // GET Npos
    getCampaignNpos (campaignId) {
      this.campaign.sorting_type = 1
      if (this.campaign.sorting_type === 2) {
        apiService
          .getQrcodeGroupedNpos(campaignId)
          .then((response) => {
            this.npos.data = response.data
            this.npos.total = response.data.length
            this.dataLoading = false
          })
          .catch((error) => {
            console.log(error)
          })
      } else {
        apiService
          .getQrcodeVoteNpos(campaignId)
          .then((response) => {
            this.npos.data = response.data
            this.npos.total = response.data.length
            this.dataLoading = false
          })
          .catch((error) => {
            console.log(error)
          })
      }
    },

    goToNpo (npo) {
      let params = {
        npoId: npo.id,
        logo: npo.logo,
        npo: npo,
        title: 'Hai scelto',
        leadId: sessionStorage.getItem('lead_id'),
        token: sessionStorage.getItem('qrcodeToken')
      }
      if (this.campaign.skipConfig && !this.isLeading) {
        params.skipConfig = true
      }
      this.$router.push({
        name: 'qrcodenpo',
        params: params
      })
    }
  }
}
</script>
<style scoped>
.container {
  background-color: #fff;
  padding: 0;
}
</style>
